export type FindStocksUrlState = {
    source: 'stocks' | 'etfs'
    positive: string[]
    negative: string[]
    page?: number
}

function parsePageParam(rawPage: string | null): number {
    const parsed = Number.parseInt(rawPage ?? '1', 10)
    if (Number.isNaN(parsed) || parsed < 1) return 1
    return parsed
}

export function parseUrlState(searchParams: URLSearchParams): FindStocksUrlState {
    const source = searchParams.get('source') === 'etfs' ? 'etfs' : 'stocks'
    const positive = searchParams.getAll('positive') || []
    const negative = searchParams.getAll('negative') || []

    // Only parse `page` when source is `etfs` (stocks do not page)
    let page: number | undefined = undefined
    if (source === 'etfs') {
        page = parsePageParam(searchParams.get('page'))
    }

    return { source, positive, negative, page }
}

export function buildSearchParams(state: FindStocksUrlState): URLSearchParams {
    const params = new URLSearchParams()
    params.set('source', state.source)
    state.positive.forEach((p) => params.append('positive', p))
    state.negative.forEach((n) => params.append('negative', n))
    // include `page` only for ETFs (stocks don't support pagination)
    if (state.source === 'etfs') {
        params.set('page', String(state.page ?? 1))
    }
    return params
}
